<template>
  <b-container fluid id="ClinicResultSubheader">
    <b-row class="pt-3">
      <b-col cols="12" class="col-lg return-link">
        <a class="service-background" href="https://clinicarx.com.br/servicos-de-saude/">
          <b-icon class="arrow-left-icon" icon="arrow-left-short"></b-icon>
          <div class="display-service">
            <label>{{ selectedServiceDefaultName && selectedServiceDefaultName.name }}</label>
            <span>Voltar para todos os serviços</span>
          </div>
        </a>
      </b-col>
    
      <b-col cols="12" lg="6" class="date-picker-trigger">
        <div @click="displayDatePicker">
          <div class="display-date">
            <label>Selecione a melhor data para o atendimento</label>
            <div class="date-picker-button">
              <span>{{ selectedFormattedDate || currentDate }}</span>
              <b-icon class="chevron-down-icon" icon="chevron-down"></b-icon>
            </div>
          </div>
        </div>
          <date-picker @selectedDate="selectedDate($event)" :showDatePicker="showDatePicker"></date-picker>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ClinicResultSubheader from "@/components/ClinicsResult/ClinicResultSubheader/ClinicResultSubheader";
export default ClinicResultSubheader;
</script>

<style lang="scss">
@import "ClinicResultSubheader.scss";
</style>
